import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";

// .env.* を参照し接続先firebaseプロジェクトの設定を取得
// localhostのエミュレータ利用の場合は末尾の条件分岐によって自動接続
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);

const auth = getAuth(firebaseApp);

const firebaseAuthEmulatorHost =
  process.env.VUE_APP_FIREBASE_AUTH_EMULATOR_HOST ??
  (location.hostname === "localhost" ? "http://localhost:9099" : undefined);

if (firebaseAuthEmulatorHost) {
  connectAuthEmulator(auth, firebaseAuthEmulatorHost);
}

export { auth };
